/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Object contains information required for creating and sending a token to restore a forgotten password.
 * @export
 * @interface PasswordRestoreTokenInput
 */
export interface PasswordRestoreTokenInput {
    /**
     * User login identifier. Target to receive the token.
     * @type {string}
     * @memberof PasswordRestoreTokenInput
     */
    loginId: string;
}

/**
 * Check if a given object implements the PasswordRestoreTokenInput interface.
 */
export function instanceOfPasswordRestoreTokenInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "loginId" in value;

    return isInstance;
}

export function PasswordRestoreTokenInputFromJSON(json: any): PasswordRestoreTokenInput {
    return PasswordRestoreTokenInputFromJSONTyped(json, false);
}

export function PasswordRestoreTokenInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordRestoreTokenInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'loginId': json['loginId'],
    };
}

export function PasswordRestoreTokenInputToJSON(value?: PasswordRestoreTokenInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'loginId': value.loginId,
    };
}

